import React, { useState } from 'react'

import Link from 'next/link'

import HeaderNavigation from 'Components/Blocks/Header/Navigation'
import StartupCraftLogo from 'Components/Blocks/StartupCraftLogo'
import { Button, Column, Row } from 'Components/UI'
import { easeIn, useMotionValueEvent, useScroll } from 'framer-motion'

import { ThreeBarsGlyph } from 'Assets/Svg/Icons'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'
import { ROOT } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

import { useAppContext } from 'Services/AppContext'

import { Background, Container, Content, MobileMenuHolder } from './styles'

const TRANSITION = {
  duration: 0.03,
  ease: easeIn,
}

const HEADER_OPACITY_SCROLL_THRESHOLD_PX = 10

function Header() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()
  const { openSupportWidget } = useAppContext()

  const { scrollY } = useScroll()

  const [isScrolled, setIsScrolled] = useState(false)

  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest >= HEADER_OPACITY_SCROLL_THRESHOLD_PX)
  })

  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false)

  const isDesktopNavigation = isDesktop || isWideDesktop

  return (
    <Container px={LANDING_INLINE_PADDINGS}>
      {!isDesktopNavigation && (
        <MobileMenuHolder
          animate={{
            height: isMobileMenuVisible ? 'fit-content' : 0,
          }}
          initial={{ height: 0 }}
          px={LANDING_INLINE_PADDINGS}
          transition={{
            height: { ease: TRANSITION.ease, duration: TRANSITION.duration },
          }}
        >
          <Column alignEnd aria-label="Main" as="nav" gap={5} pb={9}>
            <Row height="72px" noShrink />

            <HeaderNavigation />
          </Column>
        </MobileMenuHolder>
      )}

      <Background
        animate={{
          opacity: isScrolled ? 1 : 0,
        }}
        transition={{
          opacity: { ease: TRANSITION.ease, duration: TRANSITION.duration },
        }}
      />

      <Content minHeight={[76, 76, 92]}>
        <Row alignCenter gap={19}>
          <Link aria-label="StartupCraft — home" href={ROOT}>
            <StartupCraftLogo withAddon />
          </Link>

          {isDesktopNavigation && (
            <Row aria-label="Main" as="nav" gap={11}>
              <HeaderNavigation />
            </Row>
          )}
        </Row>

        <Row alignCenter gap={5}>
          <Button onClick={openSupportWidget}>Book a discovery</Button>

          {!isDesktopNavigation && (
            <Button
              square
              onClick={() => setIsMobileMenuVisible(prevState => !prevState)}
            >
              {ThreeBarsGlyph()}
            </Button>
          )}
        </Row>
      </Content>
    </Container>
  )
}

export default Header
